export const keywordPositioning = {
  frequency: {
    daily: 'Diario',
    weekly: 'Semanal',
    monthly: 'Mensual',
  },
  device: {
    desktop: 'Escritorio',
    mobile: 'Móvil',
  },
  list: {
    title: 'Posicionamiento de keywords',
    subtitle: 'Seguí cómo posiciona tu dominio en las keywords que importan.',
    newAction: 'Nueva lista',
    error: 'No se pudieron cargar tus listas de posicionamiento.',
    empty: 'Creá tu primera lista para empezar a monitorear posiciones de keywords.',
    emptyTitle: 'Aún no tenés ninguna lista de posicionamiento',
    card: {
      keywordCount_one: '{{count}} keyword',
      keywordCount_other: '{{count}} keywords',
      lastUpdated: 'Actualizado {{value}}',
      updatedNever: 'Sin actualizar',
    },
    deleteDialog: {
      success: 'Lista eliminada.',
      error: 'No se pudo eliminar la lista.',
    },
  },
  create: {
    title: 'Nueva lista de posicionamiento',
    subtitle: 'Elegí el dominio, los mercados y con qué frecuencia refrescar las posiciones.',
    success: 'Lista creada',
    submit: 'Crear lista',
    submitting: 'Creando…',
    submitError: 'No se pudo crear la lista. Revisá los datos e intentá de nuevo.',
    cancel: 'Cancelar',
    fields: {
      name: {
        label: 'Nombre',
        placeholder: 'ej. Acme — Keywords principales',
      },
      domain: {
        label: 'Dominio',
        placeholder: 'example.com',
      },
      countries: {
        label: 'Países',
        placeholder: 'Seleccioná países',
        searchPlaceholder: 'Buscar país',
        noResults: 'Ningún país coincide con tu búsqueda.',
        selectedCount_one: '{{count}} país seleccionado',
        selectedCount_other: '{{count}} países seleccionados',
      },
      language: {
        label: 'Idioma',
        placeholder: 'es',
      },
      device: {
        label: 'Dispositivo',
      },
      frequency: {
        label: 'Frecuencia de actualización',
      },
    },
    errors: {
      nameRequired: 'El nombre es obligatorio.',
      domainRequired: 'El dominio es obligatorio.',
      countriesMin: 'Seleccioná al menos un país',
      countriesMax: 'Podés seleccionar hasta 5 países.',
      languageRequired: 'El idioma es obligatorio.',
    },
  },
  appearance: {
    organic: 'Orgánico',
    ai_overview: 'AI Overview',
    featured_snippet: 'Fragmento destacado',
    not_found: 'Sin posición',
    aiOverviewCited: 'Citado en el AI Overview',
  },
  measurement: {
    unmeasurable: 'Sin medir',
    unmeasurableHint_one:
      'No pudimos leer el buscador para esta keyword en la última actualización. No es una caída de posición.',
    unmeasurableHint_other:
      'No pudimos leer el buscador para esta keyword en las últimas {{count}} actualizaciones. No es una caída de posición.',
  },
  delta: {
    new: 'Nueva',
    lost: 'Perdida',
  },
  intent: {
    informational: 'Informacional',
    navigational: 'Navegacional',
    commercial: 'Comercial',
    transactional: 'Transaccional',
  },
  intentStrength: {
    high: 'Alta',
    medium: 'Media',
    low: 'Baja',
  },
  detail: {
    backToList: 'Volver a las listas',
    notFound: 'No encontramos esta lista de posicionamiento.',
    lastUpdated: 'Actualizado {{value}}',
    updatedNever: 'Sin actualizar',
    tabs: {
      dashboard: 'Dashboard',
      keywords: 'Keywords',
      competitors: 'Competidores',
    },
  },
  competitors: {
    tabLabel: 'Competidores',
    title: 'Competidores',
    subtitle: 'Agregá dominios de competidores para comparar sus posiciones con las tuyas.',
    addPlaceholder: 'competidor.com',
    addCta: 'Agregar',
    limitReached: 'Podés seguir hasta 5 competidores por lista.',
    duplicateError: 'Este competidor ya está siendo seguido.',
    deleteAction: 'Eliminar competidor',
    empty: 'Aún no hay competidores. Agregá uno arriba para empezar a comparar posiciones.',
    error: 'No se pudieron cargar los competidores.',
    trackedFromNextUpdate: 'Los competidores se siguen a partir de la próxima actualización.',
    deleteDialog: {
      title: '¿Eliminar competidor?',
      description: 'Dejaremos de seguir "{{domain}}". Podés volver a agregarlo más tarde.',
      cancel: 'Cancelar',
      confirm: 'Eliminar',
    },
    toast: {
      added: 'Competidor agregado',
      addError: 'No se pudo agregar el competidor.',
      deleted: 'Competidor eliminado',
      deleteError: 'No se pudo eliminar el competidor.',
    },
    importFromProfile: {
      action: 'Importar desde perfil',
      title: 'Importar competidores desde el perfil',
      subtitle: 'Agregá a esta lista competidores del perfil de tu organización.',
      remainingHint_one: 'Podés agregar {{count}} competidor más.',
      remainingHint_other: 'Podés agregar {{count}} competidores más.',
      alreadyTracked: 'Ya seguido',
      cancel: 'Cancelar',
      submitWithCount: 'Agregar seleccionados ({{count}})',
      empty: 'Todavía no hay competidores en tu perfil.',
      error: 'No se pudieron cargar las sugerencias de competidores.',
      full: 'Esta lista ya sigue el máximo de 5 competidores.',
      toast: {
        imported: '{{added}} agregados, {{skipped}} omitidos',
        importError: 'No se pudieron importar los competidores.',
      },
    },
  },
  refresh: {
    updateNow: 'Actualizar ahora',
    updating: 'Actualizando…',
    toast: {
      started:
        'Actualizando posiciones. Esto puede tardar varios minutos dependiendo de la cantidad de keywords y países.',
      heavy:
        'Actualizando posiciones. Esto puede tardar varios minutos dependiendo de la cantidad de keywords y países.',
      updated: 'Posiciones actualizadas',
      alreadyRunning: 'Ya hay una actualización en curso',
      noKeywords: 'No hay keywords para actualizar — agregá keywords a la lista.',
      timedOut: 'Las posiciones siguen actualizándose en segundo plano — volvé en unos minutos.',
      error: 'No se pudo iniciar la actualización. Intentá de nuevo.',
    },
  },
  keywords: {
    add: {
      title: 'Agregar keywords',
      hint: 'Enter para sumar cada keyword a la cola — o pegá varias líneas. Se agregan todas juntas de una.',
      placeholder: 'tienda online\nlink de pago\npos móvil',
      submit: 'Agregar',
      submitWithCount: 'Agregar ({{count}})',
      removeQueued: 'Quitar {{keyword}}',
    },
    importAction: 'Importar desde research',
    searchPlaceholder: 'Buscar keywords',
    columns: {
      keyword: 'Keyword',
      volume: 'Volumen',
      intent: 'Intención',
      actions: 'Acciones',
    },
    deleteAction: 'Eliminar keyword',
    error: 'No se pudieron cargar las keywords.',
    noMatches: 'Ninguna keyword coincide con tu búsqueda.',
    empty: {
      title: 'Aún no hay keywords',
      subtitle: 'Agregá keywords arriba para empezar a seguir sus posiciones.',
      addCta: 'Agregar keywords',
      importCta: 'Importar desde research',
    },
    deleteDialog: {
      title: '¿Eliminar keyword?',
      description: 'Dejaremos de seguir "{{keyword}}". Podés volver a agregarla más tarde.',
      cancel: 'Cancelar',
      confirm: 'Eliminar',
    },
    toast: {
      added_one: '{{count}} keyword agregada',
      added_other: '{{count}} keywords agregadas',
      addedWithSkipped: '{{added}} agregadas, {{skipped}} ya existían',
      addError: 'No se pudieron agregar las keywords.',
      deleted: 'Keyword eliminada',
      deleteError: 'No se pudo eliminar la keyword.',
    },
    importModal: {
      title: 'Importar desde research',
      subtitle: 'Elegí un keyword research y seleccioná qué keywords agregar a esta lista.',
      cancel: 'Cancelar',
      submit: 'Importar',
      selectedCount_one: '{{count}} keyword seleccionada',
      selectedCount_other: '{{count}} keywords seleccionadas',
      research: {
        label: 'Keyword research',
        placeholder: 'Seleccioná un research',
        empty: 'Aún no tenés ningún research.',
        error: 'No se pudieron cargar tus researches.',
      },
      keywords: {
        searchPlaceholder: 'Buscar keywords',
        selectAll: 'Seleccionar todas',
        empty: 'Este research no tiene keywords.',
        noMatches: 'Ninguna keyword coincide con tu búsqueda.',
        error: 'No se pudieron cargar las keywords.',
        pageOf: 'Página {{page}} de {{totalPages}}',
        prevPage: 'Página anterior',
        nextPage: 'Página siguiente',
      },
      toast: {
        imported_one: '{{count}} keyword importada',
        imported_other: '{{count}} keywords importadas',
        importedWithSkipped: '{{added}} importadas, {{skipped}} ya existían',
        importError: 'No se pudieron importar las keywords.',
      },
    },
  },
  compare: {
    label: 'Comparar con',
    customLabel: 'Fecha de comparación',
    modes: {
      lastWeek: 'Semana pasada',
      lastMonth: 'Mes pasado',
      custom: 'Fecha personalizada',
    },
  },
  view: {
    label: 'Vista',
    positions: 'Posiciones',
    competencia: 'Competencia',
  },
  competitive: {
    hero: {
      stat: 'keywords donde <0>liderás</0> a tus {{competitors}} competidores',
      podium: 'en el podio (top 3)',
      avances: 'avances esta semana',
      alertas: 'alertas esta semana',
    },
    movements: {
      title: 'Movimientos · esta semana',
      passed: 'Pasaste a <0>{{domain}}</0> en <1>“{{keyword}}”</1>',
      passedBy: '<0>{{domain}}</0> te pasó en <1>“{{keyword}}”</1>',
      empty: 'Los movimientos aparecen cuando haya un snapshot anterior para comparar.',
    },
    columns: {
      keyword: 'Keyword',
      position: 'Tu posición',
      standing: 'Vs. competencia',
      movement: 'Movimiento',
    },
    volume: '{{volume}} vol',
    rank: {
      chip: '{{rank}}º de {{total}}',
      unranked: 'Sin posición',
    },
    beatenBy: 'te ganan {{names}}',
    youBeatAll: 'les ganás a los {{count}}',
    pip: {
      ahead: '{{domain}} #{{position}}',
      behind: '{{domain}} #{{position}}',
      none: '{{domain}} no aparece',
    },
    rowMovement: {
      passed: 'pasaste a {{domain}}',
      passedBy: '{{domain}} te pasó',
      none: 'sin cambios',
    },
    hint: '<0>Vista Competencia</0> oculta tipo, intención y URL para enfocar en cómo te comparás. Cambiá a “Posiciones” para el detalle completo.',
    empty: {
      noKeywords: 'Todavía no hay keywords para comparar. Agregá keywords y ejecutá una actualización.',
      noSnapshot: 'Aún no hay datos — ejecutá una actualización para comparar contra tus competidores.',
    },
    error: 'No se pudo cargar el standing competitivo.',
  },
  summary: {
    error: 'No se pudo cargar el resumen.',
    empty: {
      title: 'Aún no hay datos — ejecutá una actualización',
      subtitle: 'Usá el botón "Actualizar ahora" para obtener las posiciones de esta lista.',
      noKeywordsTitle: 'Agregá keywords para empezar a trackear',
      noKeywordsSubtitle:
        'Esta lista todavía no tiene keywords. Agregá las keywords que querés seguir y después ejecutá una actualización para ver posiciones.',
      addKeywordsCta: 'Agregar keywords',
      runUpdateCta: 'Actualizar ahora',
    },
    totalKeywords: 'Keywords totales',
    topBuckets: 'Mejores posiciones',
    top3: 'Top 3',
    top10: 'Top 10',
    top20: 'Top 20',
    changes: 'Cambios',
    improved: 'Mejoraron',
    declined: 'Bajaron',
    new: 'Nuevas',
    lost: 'Perdidas',
    appearance: 'Aparición',
    meta: 'Última actualización {{updated}} · Frecuencia: {{frequency}}',
    comparedAgainst: 'Cambios comparados contra {{date}}',
    noComparison: 'Aún no hay snapshot anterior — los cambios se verán desde la próxima actualización',
    aiOverviewOverlayHint:
      'Se cuenta ADEMÁS de la aparición orgánica: una keyword puede rankear y estar citada en el AI Overview a la vez, así que este panel puede sumar más que el total de keywords.',
  },
  table: {
    error: 'No se pudieron cargar las posiciones.',
    showing: 'Mostrando {{shown}} de {{total}}',
    sortByPosition: 'Ordenar por posición',
    showCompetitors: 'Competidores',
    columns: {
      keyword: 'Keyword',
      searchVolume: 'Vol. búsq.',
      position: 'Posición',
      type: 'Tipo',
      intent: 'Intención',
      delta: 'Cambio',
      url: 'URL',
    },
    competitorColumnTooltip: 'Posición del competidor para {{domain}}',
    filters: {
      all: 'Todas',
      searchLabel: 'Buscar',
      searchPlaceholder: 'Buscar keywords',
      appearanceLabel: 'Aparición',
      bucketLabel: 'Posición',
    },
    buckets: {
      TOP_3: 'Top 3',
      TOP_10: 'Top 10',
      TOP_20: 'Top 20',
      TOP_100: 'Top 100',
    },
    empty: {
      noDataForDate: 'Sin datos para esta fecha. Snapshot más cercano: {{date}}',
      viewNearest: 'Ver snapshot más cercano',
      noMatches: 'Ninguna keyword coincide con tus filtros.',
    },
  },
} as const
